import { render, staticRenderFns } from "./SearchTransfers.vue?vue&type=template&id=a566cd42&scoped=true"
import script from "./SearchTransfers.vue?vue&type=script&lang=js"
export * from "./SearchTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a566cd42",
  null
  
)

export default component.exports